import React from "react";
import PropTypes from "prop-types";

import { connect } from "components/atoms/DependencyHelper";

import {
  formatNumbersWithComma
} from "utils/helperServices";

import styles from "./DealDetailSummary.module.scss";

const DealDetailSummary = ({ dealData, selectedApplicationType }) => {
  const monthlyPriceDisplayLabel = formatNumbersWithComma(dealData?.monthly_recurring);
  let firstMonthPriceLable = '';
  if(dealData?.deal_delivery){
    firstMonthPriceLable = formatNumbersWithComma(parseInt(dealData?.monthly_recurring) + parseInt(dealData?.deal_delivery?.replace(/^\D+/g, "")));
  }

  let isSimonlyUpgrade = !(dealData.sim_only_flg && selectedApplicationType?.title === 'Upgrade');
  
  return (
    <div className={styles.review_block}>

      <div className={styles.review_row}>
        <div className={styles.row_item}>
          <span className={styles.row_item_head}>Application type</span>
          <span className={styles.row_item_info}>
            { selectedApplicationType?.title === "Get this deal on a new contract"
                ? "New contract"
                : selectedApplicationType?.title
            }
          </span>
        </div>

        <div className={styles.row_item}>
          <span className={styles.row_item_head}>Contract duration</span>
          <span className={styles.row_item_info}>{ dealData.payment_terms_label } months</span>
        </div>
      </div>

      <div className={styles.review_row}>
        <div className={styles.row_item}>
          <span className={styles.row_item_head}>Deal</span>
        </div>
        <div className={styles.row_item}>
          <span className={styles.row_item_info}>{dealData.name}</span>
          <span className={styles.row_item_price}>R{monthlyPriceDisplayLabel} PM</span>
        </div>
      </div>

      {(dealData?.deal_delivery && isSimonlyUpgrade) &&
      <div className={styles.review_row}>
        <div className={styles.row_item}>
          <span className={styles.row_item_head}>Delivery</span>
        </div>
        <div className={styles.row_item}>
          <span className={styles.row_item_info}>Standard once-off delivery fee. This will be added to your first month's bill </span>
          <span className={styles.row_item_price}>R{formatNumbersWithComma(dealData?.deal_delivery?.replace(/^\D+/g, ""))}</span>
        </div>
      </div>
      }

      <div className={styles.review_row}>
        
      {/* {(dealData?.deal_delivery && isSimonlyUpgrade) &&
        <div className={`${styles["row_item"]} ${styles["small_space_row"]}`}>
          <span className={styles.row_item_head}>First month's total:</span>
          <span className={styles.row_item_price}>
            R{firstMonthPriceLable}
          </span>
        </div>
      } */}
        <div className={styles.row_item}>
          <span className={styles.row_item_head}>Monthly total:</span>
          <span className={styles.row_item_price}>
            R{monthlyPriceDisplayLabel} PM x {dealData.payment_terms_label}
          </span>
        </div>
      </div>
    </div>
  );
};

DealDetailSummary.propTypes = {
  dealData: PropTypes.object,
  selectedApplicationType: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dealData: state.dealDetails.selectedDealDetails,
  selectedApplicationType: state.dealDetails.selectedApplicationType,
});

export default connect(mapStateToProps, {})(DealDetailSummary);
